import { useEffect } from 'react';
import { NextRouter } from 'next/router';

import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';
import useUI from 'hooks/use-ui';

type UseRedirectIfAgeVerificationNotApplicableProps = {
  dispensaryId: string | undefined;
  router: NextRouter;
  href: string;
};

export function useRedirectIfAgeVerificationNotApplicable({
  dispensaryId,
  router,
  href,
}: UseRedirectIfAgeVerificationNotApplicableProps): void {
  const { isEmbedded, isStoreFront } = useUI();
  const isAgeVerificationFlagEnabled = useDispensaryFlag(
    `hard-age-gate.age-verification-feature-by-dispensary`,
    dispensaryId
  );

  const isWrongVariant = !isEmbedded && !isStoreFront;

  useEffect(() => {
    if (isWrongVariant || !isAgeVerificationFlagEnabled) {
      void router.replace(href);
    }
    // we don't want router here or we get infinite renders when we push to the router stack
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [href, isAgeVerificationFlagEnabled, isWrongVariant]);
}
